import * as React from "react";

export const IconSuccess16 = () => {
  return (
    <svg
      aria-hidden="true"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M14.207 5.207 6.5 12.914 1.793 8.207l1.414-1.414L6.5 10.086l6.293-6.293 1.414 1.414Z"
        fill="#34ac0a"
      ></path>
    </svg>
  );
};



// WEBPACK FOOTER //
// ./src/bundles/honest_work/components/IconSuccess16/IconSuccess16.tsx